// Synces de pinias store between multiple tabs
import { debounce } from '../helpers/debounce'
export default defineNuxtPlugin(() => {
  const rootStore = useRootStore()
  const pinia = usePinia()

  rootStore.tabId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  window.addEventListener('storage', debounce((event: StorageEvent) => {
    if (event?.key !== 'guts' || !event.newValue) { return false }

    const stateToPatch = JSON.parse(event.newValue)
    Object.keys(stateToPatch).forEach(store => {
      if (!pinia._s.get(store)) { return }
      pinia._s.get(store).$patch(stateToPatch[store])
    })
  }, 250)
  )
})
